import { OrderedSet, Map } from 'immutable';

import { DEFAULT_TEST_CASE_SORT, TIME_INTERVAL_OPTIONS } from '../../../constants';
import { filterTestCases } from './utils';

export const createTestListReducers = (types) => {
  const initialState = Map({
    loadingData: true,
    pagination: Map({
      current: 1,
      size: 25,
    }),
    sort: Map(DEFAULT_TEST_CASE_SORT),
    testCases: OrderedSet(),
    totalTestCases: 0,
    isDownloadingCSV: false,
    stats: Map({
      statuses: {},
      avgRuntime: 0,
    }),
    trends: Map({
      histogram: OrderedSet(),
      loading: false,
      interval: TIME_INTERVAL_OPTIONS.daily.key,
      selectedBar: null,
    }),
  });

  const reducer = (state = initialState, { type, payload, meta }) => {
    switch (type) {
      case types.GET_TEST_CASES.REQUEST:
        return state.set('loadingData', true);
      case types.GET_TEST_CASES.SUCCESS:
        return state.withMutations((newState) => {
          const testCases = OrderedSet(filterTestCases(payload.test_cases, meta.status));
          newState
            .set('testCases', testCases)
            .set('loadingData', false)
            .set('totalTestCases', payload.total)
            .setIn(['stats', 'statuses'], payload.statuses)
            .setIn(['stats', 'avgRuntime'], payload.avg_runtime);
        });
      case types.GET_TEST_CASES.FAILURE:
        return state.withMutations((newState) => {
          newState
            .set('loadingData', false)
            .set('totalTestCases', initialState.get('totalTestCases'))
            .set('testCases', initialState.get('testCases'));
        });
      case types.CHANGE_PAGE:
        return state.setIn(['pagination', 'current'], payload);
      case types.CHANGE_SIZE:
        return state.setIn(['pagination', 'size'], payload);
      case types.RESET_PAGE:
        return state.setIn(['pagination', 'current'], initialState.getIn(['pagination', 'current']));
      case types.CHANGE_SORTING:
        return state.withMutations((newState) => {
          newState
            .setIn(['sort', 'direction'], payload.direction)
            .setIn(['sort', 'field'], payload.field);
        });
      case types.GET_TEST_CASES_TRENDS.REQUEST:
        return state.setIn(['trends', 'loading'], true);
      case types.GET_TEST_CASES_TRENDS.SUCCESS:
        return state.withMutations((newState) => {
          const { histogram } = payload;
          newState.set('trends', newState.get('trends').merge({
            histogram: OrderedSet(histogram),
            loading: false,
          }));
        });
      case types.GET_TEST_CASES_TRENDS.FAILURE:
        return state.setIn(['trends', 'loading'], false);
      case types.CHANGE_TRENDS_INTERVAL:
        return state.setIn(['trends', 'interval'], payload);
      case types.CHANGE_SELECTED_BAR:
        return state.setIn(['trends', 'selectedBar'], payload);
      case types.GET_TEST_CASES_CSV.REQUEST:
        return state.set('isDownloadingCSV', true);
      case types.GET_TEST_CASES_CSV.SUCCESS:
      case types.GET_TEST_CASES_CSV.FAILURE:
        return state.set('isDownloadingCSV', false);
      case types.CLEANUP:
        return initialState;
      default:
        return state;
    }
  };

  return { initialState, reducer };
};
